import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { getListCommentAPI, postNewCommentAPI } from "core/http/service/news";
import { SCREEN } from "helper/roleChecker/Screens";
import { resetComment } from "../redux/formComment";
import { getCommentsSuccess, resetComments } from "../redux/getComments";
import { postCommentStart } from "../redux/postComment";
import { getNewsDetailSuccess } from "../redux/getNewsDetail";
import { newsDetailDataSelector } from "../redux/selector";

function* postComment(action) {
  try {
    const { callback, screenCode, ...params } = action.payload;
    yield call(postNewCommentAPI, {
      ...params,
      screenCode: screenCode ?? SCREEN.IP_009,
    });
    yield put({
      type: resetComment.type,
    });
    yield put({
      type: resetControlPage.type,
    });
    yield put({
      type: resetComments.type,
    });

    const { controlPage } = yield select(controlInfinitiveScrollSelector(null));

    const payload = {
      ...controlPage,
      objectId: params.objectId,
      screenCode: params.screenCode ?? SCREEN.IP_009,
      type: params.type ?? "POST",
    };
    const res = yield call(getListCommentAPI, payload);
    const newsDetail = yield select(newsDetailDataSelector);
    yield put({
      type: getCommentsSuccess.type,
      payload: res,
    });
    yield put({
      type: getNewsDetailSuccess.type,
      payload: {
        ...newsDetail,
        totalComment: newsDetail.totalComment + 1,
      },
    });
  } catch (error: any) {}
}

function* watchPostComment() {
  yield takeLatest(postCommentStart.type, postComment);
}

export default function* postCommentSaga() {
  yield all([watchPostComment()]);
}
